import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  viewid =  '139605827';
  apikey = 'AIzaSyB9SvplsKFjUWs2PQ1ZpLoW67WOIjk9jYw';
  constructor() { 
   
  }
  getViewId(){
    return this.viewid;
  }
  getApiKey(){
    return this.apikey;
  }
}
